<!-- 暂时弃用 -->
<template>
  <div>
    <div>
      <span class="xbed-sub-title">小程序码管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>微信</BreadcrumbItem>
        <BreadcrumbItem>小程序码管理</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs class="tabs">
      <TabPane label="渠道列表" name="channelList" ref="channelList">
        <Form @submit.native.prevent="preventSubmit" inline>
          <FormItem prop="keyword" label="渠道名称：" :label-width="84">
            <Input type="text" v-model="channelList.queryParams.sourcesName" :maxlength="20"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="queryChannelListWithKeyword">查询</Button>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="openEditChannelModal">新增渠道</Button>
          </FormItem>
        </Form>


        <combo-table :query="channelListQuery" :columns="channelList.columns" :queryParams="channelList.queryParams" ref="channelListTable"></combo-table>
      </TabPane>
    </Tabs>

    <!-- Modal 内容 -->
    <Modal v-model="editChannelModal.display" ref="editChannelModal" :title="editChannelModal.id ? '编辑渠道' : '新增渠道'" :loading="true" @on-ok="preEditChannel">
      <Form @submit.native.prevent="preventSubmit" :model="editChannelModal" ref="editChannelModalForm" :rules="editChannelModal.rules" :label-width="84">
        <FormItem prop="sourcesName" label="渠道：">
          <Input type="text" :maxlength="100" v-model="editChannelModal.sourcesName" />
        </FormItem>
        <FormItem prop="rates" label="费率：">
          <!-- <InputNumber :max="1" :min="0" :step="0.001" :precision="3" style="width: 240px;" placeholder="请填写费率（例13%费率，请填写0.13）" v-model="editChannelModal.rates" /> -->
          <input type="text" style="width: 240px;" class="ivu-input" :value="editChannelModal.rates" @input="handleChangeRates" placeholder="请填写费率（例13%费率，请填写0.13）" />
        </FormItem>
        <FormItem prop="remark" label="备注：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="editChannelModal.remark" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import ComboTable from '../../components/combo-table'
import Utils from "../../utils";
import API from "../../api";
import Moment from 'moment'

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    const editChannelModalRules = {
      sourcesName: (rule, value, callback) => {
        if (this.editChannelModal.sourcesName.length === 0) {
          return callback(new Error('渠道名称不能为空'));
        }

        callback();
      },
      remark: (rule, value, callback) => {
        const MAX_LENGTH = 255
        if (this.editChannelModal.remark !== null && this.editChannelModal.remark.length > MAX_LENGTH) {
          return callback(new Error('备注不能超过255字'));
        }

        callback();
      }
    }

    return {
      channelList: {
        queryParams: {
          sourcesName: ''
        },
        columns: [
          {
            title: "ID",
            key: "scId",
            align: "center",
            width: 80
          },
          {
            title: "渠道名称",
            key: "sources",
            align: "center",
            width: 150
          },
          {
            title: "渠道费率",
            key: "sourcesRate",
            align: "center",
            width: 100
          },
          {
            title: "备注",
            key: "remark",
            align: "center",
            width: 150
          },
          {
            title: "创建时间",
            key: "createTime",
            align: "center",
            width: 220,
            render: (h, params) => {
              let createTime = Moment(params.row.createTime).format('YYYY-MM-DD HH:mm:ss');
              return h("div", {}, createTime);
            }
          },
          {
            title: "修改时间",
            key: "modifyTime",
            align: "center",
            width: 220,
            render: (h, params) => {
              let modifyTime = Moment(params.row.modifyTime).format('YYYY-MM-DD HH:mm:ss');
              return h("div", {}, modifyTime);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: '8px'
                    },
                    on: {
                      click: () => {
                        this.openEditChannelModal({
                          id: params.row.scId,
                          sourcesName: params.row.sources,
                          rates: params.row.sourcesRate, // || 0.135, // 默认费率
                          remark: params.row.remark
                        });
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: "提示",
                          content: `确定删除${params.row.scId} - ${params.row.sources}吗？\n一经确定将无法修改`,
                          okText: "确定删除",
                          cancelText: "取消",
                          onOk: () => {
                            this.delChannel(params.row.scId)
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ]
      },
      editChannelModal: {
        display: false,
        id: '',
        sourcesName: '',
        rates: '', // 默认费率
        remark: '',
        rules: {
          sourcesName: [{ required: true, trigger: 'blur', validator: editChannelModalRules.sourcesName }],
          remark: [{ required: false, trigger: 'blur', validator: editChannelModalRules.remark }]
        }
      }
    }
  },
  methods: {
    // 通过关键字搜索列表
    queryChannelListWithKeyword() {
      this.channelList.queryParams.sourcesName = this.channelList.queryParams.sourcesName.trim();

      this.$nextTick(() => {
        this.$refs.channelListTable.reload();
      })
    },
    // 渠道列表
    channelListQuery(params) {
      return API.omsAPI[this.env].wechat.getSources(params,this.token)
    },
    // 打开渠道modal
    openEditChannelModal(channel = {}) {
      // 重置表单
      this.$refs.editChannelModalForm.resetFields()

      // 初始化modal
      this.editChannelModal = Object.assign({}, this.editChannelModal, {
        display: true,
        id: '',
        sourcesName: '',
        rates: '', // 默认费率
        remark: ''
      }, channel)
    },
    // 改变费率(小数保留三位)
    handleChangeRates (event) {
      const precision = 3; // 保留位数
      let rates = event.target.value.trim();

      const isEmptyString = rates.length === 0;

      // 如果是空字符串
      if(isEmptyString){
        event.target.value = null;
        this.editChannelModal.rates = null;
        return;
      }

      if (!isNaN(rates) && !isEmptyString) {
        const MAX = 1 // 最大值
        const MIN = 0 // 最小值
        if (rates > MAX) { // 如果超出最大值
          event.target.value = Number(Number(MAX).toFixed(precision));
        } else if (rates < MIN) { // 如果小于最小值
          event.target.value = Number(Number(MIN).toFixed(precision));
        } else {
          event.target.value = rates.substring(0, rates.indexOf(".") + precision + 1) // 超出3位小数需要截取
        }
      } else { // 如果不能转化成number
        event.target.value = this.editChannelModal.rates;
      }

      this.editChannelModal.rates = event.target.value;
    },
    // 编辑渠道modal
    async preEditChannel () {
      let validResult = false;
      this.$refs.editChannelModalForm.validate((valid) => {
        // 判断费率
        if (this.editChannelModal.rates === '' || this.editChannelModal.rates === null || isNaN(this.editChannelModal.rates)) {
          this.$Notice.error({
            title: '请输入正确的费率'
          })

          valid = false
        }
        validResult = valid
      })
      if (!validResult) {
        this.$refs.editChannelModal.buttonLoading = false;
        return
      }

      let params = {
        sourcesName: this.editChannelModal.sourcesName,
        sourcesRate: this.editChannelModal.rates
      }
      this.editChannelModal.id && (params.scId = this.editChannelModal.id)
      this.editChannelModal.remark !== null && this.editChannelModal.remark.length > 0 && (params.remark = this.editChannelModal.remark)

      const resp = (await API.omsAPI[this.env].wechat.updateSources(params, this.token)).data

      if(resp.retCode){
        // 失败
        this.$Notice.error({
          title: `操作失败`,
          desc: resp.msg
        });

        this.$refs.editChannelModal.buttonLoading = false;
      } else {
        this.$Notice.success({
          title: "操作成功",
        });

        // 关闭弹窗
        this.editChannelModal.display = false
        this.$refs.channelListTable.reload()
      }
    },
    // 删除渠道
    async delChannel (sourcesId) {
      const resp = (await API.omsAPI[this.env].wechat.deleteSources(sourcesId, this.token)).data

      if(resp.retCode){
        // 失败
        this.$Notice.error({
          title: "删除失败",
          desc: resp.msg
        });
      }else{
        this.$Notice.success({
          title: "删除成功",
        });

        this.$refs.channelListTable.reload()
      }
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    }
  },
  components: {
    'combo-table': ComboTable
  }
}
</script>

<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/pages/wechat/wx-qrCode.vue